export function Footer() {
  return (
    <footer className="py-12 px-6 bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          {/* Brand */}
          <div className="text-center md:text-left max-w-sm">
            <h3 className="text-lg font-bold text-white">Levier IA</h3>
            <p className="text-sm text-slate-400 mt-1 leading-relaxed">
              Conseil IA & refonte web pour entreprises françaises.
              L'IA opérationnelle, hébergée en France.
            </p>
          </div>

          {/* Links */}
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-slate-400">
            <a href="#why-now" className="hover:text-white transition-colors">
              Pourquoi maintenant
            </a>
            <a href="#services" className="hover:text-white transition-colors">
              Services
            </a>
            <a href="#process" className="hover:text-white transition-colors">
              Processus
            </a>
            <a href="#pricing" className="hover:text-white transition-colors">
              Tarifs
            </a>
            <a href="#faq" className="hover:text-white transition-colors">
              FAQ
            </a>
            <a
              href="mailto:contact@levier-ia.fr"
              className="hover:text-white transition-colors"
            >
              Contact
            </a>
          </nav>

          {/* CTA */}
          <a
            href="#cta"
            className="self-center md:self-start px-5 py-2.5 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-500 transition-colors shadow-lg shadow-blue-600/20 whitespace-nowrap"
          >
            Audit gratuit
          </a>
        </div>

        {/* Legal & sovereignty footer */}
        <div className="mt-10 pt-8 border-t border-slate-800 space-y-4">
          <p className="text-xs text-slate-500 text-center leading-relaxed">
            <strong className="text-slate-400">Levier IA SAS</strong> — SIRET 99 149 711 600 012 · APE 7022Z
            <br className="sm:hidden" />
            <span className="hidden sm:inline"> · </span>
            229 rue Saint-Honoré, 75001 Paris
          </p>
          <p className="text-xs text-slate-500 text-center leading-relaxed">
            Hébergement <strong className="text-slate-400">OVHcloud Roubaix</strong> (France) ·
            CDN Cloudflare · Workshops Passeport IA : agrément Qualiopi en cours
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-600 pt-2">
            <p>© {new Date().getFullYear()} Levier IA. Tous droits réservés.</p>
            <div className="flex items-center gap-4">
              <a
                href="https://levier-ia.fr/legal/privacy"
                target="_blank"
                rel="noopener"
                className="hover:text-slate-400 transition-colors"
              >
                Confidentialité
              </a>
              <a
                href="https://levier-ia.fr/legal/mentions"
                target="_blank"
                rel="noopener"
                className="hover:text-slate-400 transition-colors"
              >
                Mentions légales
              </a>
              <a
                href="mailto:contact@levier-ia.fr"
                className="hover:text-slate-400 transition-colors"
              >
                contact@levier-ia.fr
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
